import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Box, Card } from '@paygreen/paygreen-ui';
import { timestampToDate } from '../../../utils/tools';
import { partnershipStatus } from '../../../utils/constants';
import { useUser } from '../../../context';
import { ErrorBoundary } from '../../../components';
import PartnershipCardHeader from './PartnershipCardHeader';
import PartnershipDispatchData from './PartnershipDispatchData';
import CornerRemoveFromPartnershipGroup from './CornerRemoveFromPartnershipGroup';
import { BorderBottom } from './PartnershipCard.styled';

const PartnershipCard = ({
    children,
    data,
    isLastPartnership,
    partnershipStatus,
    partnershipGroupStatus,
    partnershipsGroupName,
    removeFromPartnershipGroup,
    isInPartnershipGroupCard,
    blockWidth,
    hasBorderBottom,
}) => {
    const { user } = useUser();

    const formattedData = useMemo(
        () => PartnershipDispatchData(data, partnershipStatus, user),
        [data, partnershipStatus, user],
    );

    return (
        <ErrorBoundary>
            <Card
                hasBackground={true}
                blockWidth={blockWidth}
                radiusSize="sm"
                colorTheme="quaternary"
                isShadowWab={true}
            >
                {isInPartnershipGroupCard ? (
                    <CornerRemoveFromPartnershipGroup
                        removeFromPartnershipGroup={removeFromPartnershipGroup}
                        isLastPartnership={isLastPartnership}
                        partnerName={formattedData.partnerName}
                        partnershipsGroupName={partnershipsGroupName}
                    />
                ) : null}

                <Box marginRight="sm">
                    <PartnershipCardHeader
                        partnerName={formattedData.partnerName}
                        partnershipDate={timestampToDate(
                            formattedData.partnershipDate,
                        )}
                        partnershipGroupStatus={partnershipGroupStatus}
                        partnershipStatus={partnershipStatus}
                        isInPartnershipGroupCard={isInPartnershipGroupCard}
                        partnershipImage={formattedData.picture1}
                    />
                </Box>

                {children}

                {hasBorderBottom ? <BorderBottom /> : null}
            </Card>
        </ErrorBoundary>
    );
};

PartnershipCard.propTypes = {
    blockWidth: PropTypes.string,
    hasBorderBottom: PropTypes.bool,
    removeFromPartnershipGroup: PropTypes.func,
    partnershipGroupStatus: PropTypes.string,
    partnershipsGroupName: PropTypes.string,
    partnershipStatus: PropTypes.oneOf(Object.values(partnershipStatus)),
    isInPartnershipGroupCard: PropTypes.bool,
    isLastPartnership: PropTypes.bool,
    data: PropTypes.object,
};

PartnershipCard.defaultProps = {
    blockWidth: 'md',
    hasBorderBottom: true,
    isInPartnershipGroupCard: false,
    isLastPartnership: false,
};

export default withTranslation('common')(PartnershipCard);
